export enum CarePlanInterventionStatus {
  PLANNED = 'PLANNED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  VOID = 'VOID',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
}
